import "../../assets/css/marketplace.css"
import "../../assets/css/icons.css"
// import './styles/newstyles.css';
// import './styles/icons.css';

function SideIcon() {
  return (
    <div>
      <div className="fixed-community-icons">
        <div className="social-icons-side">
          <a
            href="https://t.me/NucleusVision_ann"
            target="_blank"
            title="Telegram">
            <i className="fab fa-telegram" aria-hidden="true"></i>
          </a>
          <a
            href="https://twitter.com/NucleusVision"
            target="_blank"
            title="Twitter">
            <i className="fab fa-twitter" aria-hidden="true"></i>{" "}
          </a>
          <a
            href="https://medium.com/@NucleusVision"
            target="_blank"
            title="Medium">
            <i className="fab fa-medium" aria-hidden="true"></i>{" "}
          </a>
          <a
            href="https://www.linkedin.com/company/nucleusvision/"
            target="_blank"
            title="Linkedin">
            <i className="fab fa-linkedin-square" aria-hidden="true"></i>{" "}
          </a>
          <a
            href="https://www.facebook.com/NucleusVision-1626428670765385/"
            target="_blank"
            title="Facebook">
            <i className="fab fa-facebook" aria-hidden="true"></i>{" "}
          </a>
          <a
            href="https://www.youtube.com/channel/UCJ4LIGyMee0HnAx4rDvX0nw"
            target="_blank"
            title="Youtube">
            <i className="fab fa-youtube" aria-hidden="true"></i>{" "}
          </a>
          <a
            href="https://www.reddit.com/r/NucleusVision/"
            target="_blank"
            title="Reddit">
            <i className="fab fa-reddit-alien" aria-hidden="true"></i>{" "}
          </a>
        </div>
      </div>
    </div>
  )
}

export default SideIcon
